var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c("datepicker", {
        ref: "datePicker",
        staticClass: "dateStyle",
        attrs: {
          "bootstrap-styling": true,
          "calendar-button": true,
          "clear-button": _vm.clearButton,
          format: _vm.customFormatter,
          language: _vm.fr,
          "calendar-button-icon": "fa fa-calendar",
          "clear-button-icon": "fa fa-times",
        },
        on: {
          input: function ($event) {
            _vm.$emit("input", _vm.customFormatter(_vm.inputDate))
          },
        },
        model: {
          value: _vm.inputDate,
          callback: function ($$v) {
            _vm.inputDate = $$v
          },
          expression: "inputDate",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }